import {MediaFileType} from "../../libs/enum/media-file-type.enum";

export class MediaDto {

  public readonly id!: string;
  public readonly type!: MediaFileType;
  public readonly filename!: string;
  public readonly contentType!: string;
  public readonly size!: number;

  constructor(init?: Partial<MediaDto> | undefined) {
    Object.assign(this, init);
  }
}
